import logoWhite from "../../assets/brand/cgmg-logo-white.png";
import { useTranslation } from "react-i18next";
import { useContent } from "../../i18n/useContent";
import { useSectionHref } from "../../seo/RouteContext";
import { PAGE_LINKS } from "../../seo/pageLinks";
import { NAP, telHref } from "../../seo/site";
import "./Footer.css";

export default function Footer() {
  const { contact, footer, nav, site } = useContent();
  const { t } = useTranslation();
  const sectionHref = useSectionHref();

  return (
    <footer className="footer">
      <div className="container footer-main">
        <div className="footer-col">
          <img src={logoWhite} alt={site.name} className="footer-logo" />
          <p className="footer-blurb">{footer.blurb}</p>
          <p className="footer-closing">{footer.closing}</p>
        </div>

        <nav className="footer-col" aria-label={t("a11y.quickLinks")}>
          <h3 className="footer-heading">{footer.navHeading}</h3>
          <ul className="footer-nav">
            {nav.map((item) => (
              <li key={item.id}>
                <a href={sectionHref(item.id)}>{item.label}</a>
              </li>
            ))}
          </ul>
        </nav>

        <nav className="footer-col" aria-label={footer.pagesHeading}>
          <h3 className="footer-heading">{footer.pagesHeading}</h3>
          <ul className="footer-nav">
            {PAGE_LINKS.map((l) => (
              <li key={l.id}>
                <a href={l.href}>{t(`nav.sub.${l.id}`)}</a>
              </li>
            ))}
          </ul>
        </nav>

        <div className="footer-col">
          <h3 className="footer-heading">{contact.office.title}</h3>
          {/* NAP: spelled exactly as in the contact section and the schema. */}
          <address className="footer-address">
            <strong className="footer-nap-name">{NAP.name}</strong>
            <br />
            {NAP.addressLine}
            <br />
            {footer.phoneLabel}: <a href={telHref}>{NAP.phoneDisplay}</a>
          </address>
          <a
            className="footer-map-link"
            href={contact.office.mapsHref}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("common.viewOnMap")}
          </a>
        </div>
      </div>

      <div className="container footer-bottom">
        <p className="footer-copyright">{footer.copyright}</p>
        <p className="footer-credit">{site.motto}</p>
      </div>
    </footer>
  );
}
